<template>
  <!-- 高职高考-明师教育 -->
  <div class="pc-bg" @scroll="scrollfn" ref="bigbox">
    <div class="pc-main" ref="main">
      <div v-for="(item, i) in imgList" :key="i" ref="img" class="pc-img-box">
        <img :src="item.img" class="pc-bgimg" v-if="item.show" :id="id(i)" />
        <div class="pc-box" v-if="i === 3">
          <swiper :options="swiperOption" class="swiper">
            <swiper-slide
              v-for="(item, index) in 5"
              :key="index"
              class="swiper-slide"
            >
              <img
                :src="require(`@/assets/img/pcgaofu/bnaner/bg-${item}.png`)"
                class="pc-img"
              />
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination"></div>
          <!-- <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
          <div class="swiper-pagination"></div> -->
        </div>
      </div>
    </div>
    <div class="pc-bottom" ref="bottom">
      <i>© 重本紫腾教育科技（广州）有限公司 版权所有。</i>
      <a class="pc-beian" href="https://beian.miit.gov.cn"
        >粤ICP备2021074338号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = "重本·紫腾     高复高考";
  },
  data() {
    return {
      isShow: false,
      showNum: 2,
      swiperOption: {
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        // 自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        autoplayDisableOnInteraction: false,
        // 设置轮播
        // effect: 'flip',
        effect: "slide",
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "horizontal",
        // 分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      fake: [
        {
          top: "top: 965px;",
        },
        {
          top: "top: 3300px;",
        },
        {
          top: "top: 4300px;",
        },
        {
          top: "top: 4300px;",
        },
      ],
      imgList: [
        {
          img: require("@/assets/img/pcgaofu/1.png"),
          show: true,
        },
        {
          img: require("@/assets/img/pcgaofu/2.png"),
          show: true,
        },
        {
          img: require("@/assets/img/pcgaofu/3.png"),
          show: true,
        },
        {
          img: require("@/assets/img/pcgaofu/4.png"),
          show: false,
        },
        // {
        //   img: require("@/assets/img/pcgaofu/5.png"),
        //   show: false,
        // },
        {
          img: require("@/assets/img/pcgaofu/6.png"),
          show: false,
        }
      ],
      banner: [],
    };
  },
  methods: {
    scrollfn() {
      if (this.$refs.bigbox.scrollTop >= 755) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      if (
        this.$refs.main.offsetHeight -
          (this.$refs.bigbox.scrollTop + this.$refs.bigbox.offsetHeight) +
          this.$refs.bottom.offsetHeight <
        50
      ) {
        this.showNum++;
        if (this.showNum >= this.imgList.length) return;
        console.log(this.imgList);
        this.imgList[this.showNum].show = true;
      }
    },
    goActivity(item) {
      if (item.link) {
        window.location.href = item.link;
      }
    },
    id(id) {
      return "No" + id;
    },
    go(val, i) {
      document.querySelector(`#No${i}`).scrollIntoView(true);
    },
    goLink() {
      window.location.href =
        "https://m.liangpinedu.cn/special/eventsgd/index.html?n=20210516jdyx#gwzxbmldy";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.pc-bg {
  /* position: absolute; */
  /* left: 50%; */
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  /* margin: 0 auto;
    transform: translateX(-50%); */

  .pc-img-box {
    position: relative;
    width: 100%;
    height: auto;
    content-visibility:auto;
    .pc-bgimg {
      display: block;
      width: 100%;
    }
    /* 定位的导航栏 */
    .pc-absoluteBox {
      position: absolute;
      top: 0;
      left: 50%;
      width: 39.58%;
      height: 100%;
      /* background-color: rgba(0, 0, 0, .5); */
      transform: translateX(-50%);
      box-sizing: border-box;

      .pc-fake-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
        /* height: 70px; */
        /* padding: 0 15px; */
        box-sizing: border-box;

        .pc-fake {
          width: 21.5%;
          height: 100%;
        }
      }
    }
    /* 定位的导航栏 */
  }
}

.pc-box {
  position: absolute;
  top: 6.9%;
  left: 50%;
  transform: translateX(-50%);
  width: 75%;
  height: 53.7%;
  overflow: hidden;
}
.pc-swiper {
  width: 100%;
  height: 100%;
}
.pc-box2 {
  position: absolute;
  top: 9.9%;
  left: 50%;
  width: 75%;
  height: 86.7%;
  border-radius: unset;
  // overflow: hidden;
  transform: translateX(-50%);
}
.pc-box3 {
  position: absolute;
  top: 9.75%;
  left: 30%;
  width: 36.8%;
  height: 9.6%;
  border-radius: unset;
  // overflow: hidden;
  transform: translateX(-50%);
}
.pc-box4 {
  position: absolute;
  top: 9.75%;
  right: 30%;
  width: 36.8%;
  height: 9.6%;
  border-radius: unset;
  // overflow: hidden;
  transform: translateX(50%);
}
.pc-box5 {
  position: absolute;
  top: 25.25%;
  left: 30%;
  width: 36.8%;
  height: 9.6%;
  border-radius: unset;
  // overflow: hidden;
  transform: translateX(-50%);
}
.pc-box6 {
  position: absolute;
  top: 25.25%;
  right: 30%;
  width: 36.8%;
  height: 9.6%;
  border-radius: unset;
  // overflow: hidden;
  transform: translateX(50%);
}

.swiper {
  width: 100%;
  height: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: #fff;
    overflow: hidden;
    .pc-img {
      max-width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.pc-none {
  /* display: none; */
  position: absolute;
  left: 0;
  width: 100%;
  height: 0;
}

/* .fixedBox {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 78px;
    background: url('../assets/img/fixed.png') no-repeat;
    background-size: 100%;
  } */
/* 跳转活动 */
.pc-activity {
  position: absolute;
  top: 6095px;
  left: 50%;
  transform: translateX(-50%);
  width: 700px;
  height: 282px;
  /* background-color: rgba(0,0,0,.7); */
}

.pc-act-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.pc-activity-big {
  display: flex;
  width: 340px;
  height: 98px;
  margin-bottom: 20px;
  border-radius: 15px;
  overflow: hidden;
}

.pc-activity-small {
  width: 50%;
  height: 100%;
}

.pc-oneOnOne {
  width: 100%;
  height: 46px;
  border-radius: 21px;
}
/* 跳转活动 */
.pc-swiper3 {
  width: 100%;
  height: 100%;
}

.swiper-pagination {
  position: absolute;
  bottom: 0;
  right: left;
}

#pc-btn {
  position: fixed;
  top: 500px;
  right: 30px;
}

.pc-clickbox {
  position: absolute;
  top: 3938px;
  left: 50%;
  transform: translateX(-50%);
  width: 701px;
  height: 350px;
  border-radius: 20px;
  overflow: hidden;
}

.pc-right {
  width: 100%;
  height: 100%;
}

.pc-right > img {
  width: 100%;
  object-fit: fill;
}

.pc-left {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 46px;
}

.pc-option {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33.3%;
  height: 100%;
  font-size: 20px;
  color: #666666;
  background: #e2e2e2;
}

.pc-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33.3%;
  height: 100%;
  font-size: 20px;
  color: #fff;
  background: #db4527;
}

.pc-call {
  position: absolute;
  top: 8599px;
  left: 640px;
  display: block;
  width: 390px;
  height: 40px;
}

.pc-bottom {
  width: 100%;
  height: 30px;
  /* padding-bottom: 80px; */
  font-size: 14px;
  line-height: 30px;
  color: #999;
  text-align: center;
  background-color: #4a4a4a;
}

.pc-beian {
  color: #999;
  text-decoration: none;
}

.pc-beian:hover {
  text-decoration: underline;
}
.my-bullet {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  background-color: #b2aba1;
  border-radius: 50%;
  opacity: 0.4;
}

.my-bullet-active {
  background: #fff;
  opacity: 1;
}
.swiper-button-prev {
  left: -9% !important;
  width: 7%;
  height: 12%;
  background-image: unset;
}

.swiper-button-next {
  right: -9%;
  width: 7%;
  height: 12%;
  background-image: unset;
}
</style>
<style>
.my-bullet {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  background-color: #b2aba1;
  border-radius: 50%;
  opacity: 0.4;
}

.my-bullet-active {
  background: #fff;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/gk.vue